// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"112":"d3ae96e9","389":"3baee2d4","443":"b437c188","471":"fa5e07b5","568":"12277c57","687":"361532b6","840":"ec775337"}[chunkId] + ".js";
};